import { render } from "./CreateNewCallQueueTimeSlot.vue?vue&type=template&id=a906b314"
import script from "./CreateNewCallQueueTimeSlot.vue?vue&type=script&lang=js"
export * from "./CreateNewCallQueueTimeSlot.vue?vue&type=script&lang=js"

import "./CreateNewCallQueueTimeSlot.vue?vue&type=style&index=0&id=a906b314&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__